import { fromPromise } from "@apollo/client/core";
import { onError } from "@apollo/client/link/error";
import { ApolloNetworkError } from "app/error-handler/custom-errors/apollo-network-error";
import { TimeoutError } from "app/error-handler/custom-errors/timeout.error";
import { AuthService } from "app/shared/auth/auth.service";
import { lastValueFrom } from "rxjs";

export const ApolloOnErrorLink = ( errorHandler: any, authService?: AuthService) => {
 return onError(({ forward, graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      if (graphQLErrors.some(err => err.message.toLowerCase() === 'forbidden resource')) {
        return fromPromise(lastValueFrom(authService.refreshToken())).flatMap(() => forward(operation));
      }
      graphQLErrors.map(err => errorHandler.handleError(err));
      return;
    }

    if (networkError) {
      let err = networkError;
      if(err instanceof TimeoutError) {
        const message = `Timeout exceeded. operation: ${operation.operationName} variables: ${JSON.stringify(operation.variables)}`;
        err.message = message;
      } else {
        const {message, cause } = networkError;
        if(cause) {
          err = new ApolloNetworkError(message, cause['code'] as string | 'unknown', 503);
        }
      }
      errorHandler.handleError(err);
    }
    return;
  });
}
